import { AlertCircle, CheckCircle2, Clock } from "lucide-react";

interface EventStatusInput {
  acknowledgedAt: string | null;
  reasonStatus: "PENDING" | "JUSTIFIED";
}

type Visual = {
  label: string;
  icon: typeof AlertCircle;
  className: string;
  short?: string;
};

export function getEventStatusVisual(e: EventStatusInput): Visual {
  if (e.reasonStatus === "JUSTIFIED") {
    return {
      label: "Justificado",
      icon: CheckCircle2,
      className: "border-rd-success-500/30 bg-rd-success-50 text-rd-success-700",
    };
  }
  if (e.acknowledgedAt) {
    return {
      label: "Reconhecido pendente de justificativa",
      short: "Reconhecido pendente",
      icon: Clock,
      className: "border-rd-warning-500/30 bg-rd-warning-50 text-rd-warning-700",
    };
  }
  return {
    label: "Ativo",
    icon: AlertCircle,
    className: "border-rd-danger-500/30 bg-rd-danger-50 text-rd-danger-700",
  };
}

interface Props extends EventStatusInput {
  compact?: boolean;
}

export function EventStatusBadge({ compact, ...e }: Props) {
  const v = getEventStatusVisual(e);
  const Icon = v.icon;
  const text = compact ? (v.short ?? v.label) : v.label;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-medium ${v.className}`}
      aria-label={v.label}
      role="status"
    >
      <Icon className="h-3 w-3" strokeWidth={2} aria-hidden="true" />
      {text}
    </span>
  );
}
